const DEVICE_REPOSITORY_LIST_SUCCESS = "DEVICE_REPOSITORY_LIST_SUCCESS";
const DEVICE_REPOSITORY_LIST_FAIL = "DEVICE_REPOSITORY_LIST_FAIL";
const DEVICE_REPOSITORY_CREATE_SUCCESS = "DEVICE_REPOSITORY_CREATE_SUCCESS";
const DEVICE_REPOSITORY_CREATE_FAIL = "DEVICE_REPOSITORY_CREATE_FAIL";
const DEVICE_REPOSITORY_CREATE_RESET = "DEVICE_REPOSITORY_CREATE_RESET";
const DEVICE_REPOSITORY_SELECTED_SUCCESS = "DEVICE_REPOSITORY_SELECTED_SUCCESS";
const DEVICE_REPOSITORY_SELECTED_FAIL = "DEVICE_REPOSITORY_SELECTED_FAIL";
const DEVICE_REPOSITORY_LOADED = "DEVICE_REPOSITORY_LOADED";
const DEVICE_REPOSITORY_UPDATE_SUCCESS = "DEVICE_REPOSITORY_UPDATE_SUCCESS";
const DEVICE_REPOSITORY_UPDATE_FAIL = "DEVICE_REPOSITORY_UPDATE_FAIL";
const DEVICE_REPOSITORY_GET_SUCCESS = "DEVICE_REPOSITORY_GET_SUCCESS";
const DEVICE_REPOSITORY_GET_FAIL = "DEVICE_REPOSITORY_GET_FAIL";
const DEVICE_REPOSITORY_DELETE_SUCCESS = "DEVICE_REPOSITORY_DELETE_SUCCESS";
const DEVICE_REPOSITORY_DELETE_FAIL = "DEVICE_REPOSITORY_DELETE_FAIL";
const DEVICE_REPOSITORY_GET_ALL_SUCCESS = "DEVICE_REPOSITORY_GET_ALL_SUCCESS";

export const defaultDeviceRepositoryState = {
  error: false,
  created: false,
  updated: false,
  repository: null,
  repositories: null,
  allRepositories: null,
  repositoryId: null,
  errorMessage: null
};

export default (state = defaultDeviceRepositoryState, action) => {
  switch (action.type) {
    case DEVICE_REPOSITORY_LIST_SUCCESS:
      return {
        ...state,
        repositories: action.payload.data
      };
    case DEVICE_REPOSITORY_LIST_FAIL:
      return {
        ...state,
        repositories: null
      };
    case DEVICE_REPOSITORY_CREATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          created: true,
          repository: action.meta.previousAction.payload.request.data.request,
          repositoryId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          created: false,
          error: true
        };
      }
    }
    case DEVICE_REPOSITORY_CREATE_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case DEVICE_REPOSITORY_CREATE_RESET:
      return {
        ...state,
        created: false,
        repository: null,
        repositoryId: null,
        error: false
      };
    case DEVICE_REPOSITORY_SELECTED_SUCCESS:
      return {
        ...state,
        created: false,
        repository: action.payload.data,
        repositoryId: action.payload.data.id,
        error: false
      };
    case DEVICE_REPOSITORY_SELECTED_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case DEVICE_REPOSITORY_LOADED: {
      return {
        ...state,
        created: false,
        repository: action.data.repository,
        repositoryId: action.data.repository.id,
        error: false
      };
    }

    case DEVICE_REPOSITORY_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          repositoryId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }

    case DEVICE_REPOSITORY_UPDATE_FAIL: {
      return {
        ...state,
        updated: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }

    case DEVICE_REPOSITORY_GET_SUCCESS: {
      return {
        ...state,
        repository: action.payload.data,
        repositoryId: action.payload.data.id
      };
    }
    case DEVICE_REPOSITORY_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case DEVICE_REPOSITORY_DELETE_SUCCESS: {
      return {
        ...state
      };
    }
    case DEVICE_REPOSITORY_DELETE_FAIL: {
      return {
        ...state
      };
    }
    case DEVICE_REPOSITORY_GET_ALL_SUCCESS: {
      return {
        ...state,
        allRepositories: action.payload.data
      };
    }
    default: 
      return {
        ...state
      };
  }
};
